import script from "./category-proportion.vue?vue&type=script&lang=ts&setup=true"
export * from "./category-proportion.vue?vue&type=script&lang=ts&setup=true"

import "./category-proportion.vue?vue&type=style&index=0&id=239618e7&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239618e7"]])

export default __exports__